module.exports = __webpack_public_path__ + "static/media/12UNCTAD18.2f76fc19.jpg";